import { useEffect } from "react";

const BRAND = "The ShopAdvisor™";
const SITE = "https://theshopadvisor.com";
const set = (sel, attr, val) => { const el = document.querySelector(sel); if (el) el.setAttribute(attr, val); };

export const usePageMeta = (title, description, canonical, noindex = false) => {
  useEffect(() => {
    document.title = title ? `${title} | ${BRAND}` : `${BRAND} | Complete Checkpoint System for Auto Repair Shops`;
    set('meta[property="og:title"]', "content", document.title);
    set('meta[name="twitter:title"]', "content", document.title);
    const url = canonical ? (canonical.startsWith("/") ? `${SITE}${canonical}` : canonical) : `${SITE}${window.location.pathname === "/" ? "/" : window.location.pathname}`;
    const link = document.querySelector('link[rel="canonical"]');
    if (noindex && !canonical) link?.remove();
    else if (link) link.setAttribute("href", url);
    else { const l = document.createElement("link"); l.rel = "canonical"; l.href = url; document.head.appendChild(l); }
    set('meta[property="og:url"]', "content", url);
    set('meta[name="robots"]', "content", noindex ? "noindex, follow" : "index, follow");
    if (description) {
      set('meta[name="description"]', "content", description);
      set('meta[property="og:description"]', "content", description);
      set('meta[name="twitter:description"]', "content", description);
    }
  }, [title, description, canonical, noindex]);
};

export const useJsonLd = (id, data) => {
  const json = data ? JSON.stringify(data) : "";
  useEffect(() => {
    if (!json) return undefined;
    const s = document.createElement("script");
    s.type = "application/ld+json"; s.id = `ld-${id}`; s.text = json;
    document.head.appendChild(s);
    return () => s.remove();
  }, [id, json]);
};
